import { useQuery } from '@tanstack/react-query';

import { dictionaryTypes } from '../types';

import { dictionaryApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getAddons = (
  viewMode: dictionaryTypes.ViewMode
): Promise<dictionaryApiTypes.ListAddonsResponse> => {
  return axios.get('/addons', { params: { viewMode } });
};

type QueryFnType = typeof getAddons;

type UseGetAddonsOptions = {
  viewMode: dictionaryTypes.ViewMode;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAddons = ({ viewMode, config = {} }: UseGetAddonsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    // Opt out of the global refetchOnMount: false. Archive/restore invalidate
    // both viewMode keys, but only the mounted one is refetched — the other is
    // just marked stale and would be served from cache on the next mount.
    refetchOnMount: true,
    ...config,
    queryKey: ['addons', viewMode],
    queryFn: () => getAddons(viewMode),
  });
};
